import React from 'react';
import { formatDateMMDDYY } from '@mummssoftware/utils/formatters';
import Checkbox from '@material-ui/core/Checkbox';
import { VisitHeader } from './VisitHeader';
import { VisitContents } from './VisitContents';
import { DialogBox } from '../Dialog';
import { defaults } from './en';
import { VisitModalDiv } from './WrapperDiv';

const getVisitDetailsTitle = visitDetails => {
  if (!visitDetails) return '';
  const {
    effectivedatetime,
    facetofacevisit,
    visittype
  } = visitDetails;
  return `${facetofacevisit ? defaults.faceToFace : visittype} ${formatDateMMDDYY(effectivedatetime)}`;
};

export const VisitModal = ({
  modalOpen,
  visitDetails,
  onClick,
  agency,
  keycloak,
  patientNumber,
  ManifestWidget
}) => /*#__PURE__*/React.createElement(DialogBox, {
  open: modalOpen,
  maxWidth: "xl",
  handleClick: onClick,
  title: getVisitDetailsTitle(visitDetails)
}, /*#__PURE__*/React.createElement(VisitModalDiv, null, /*#__PURE__*/React.createElement(VisitHeader, {
  dto: visitDetails
}), /*#__PURE__*/React.createElement(VisitContents, {
  dto: visitDetails,
  editing: false,
  editF2F: () => /*#__PURE__*/React.createElement(Checkbox, {
    checked: true,
    onChange: () => null,
    disabled: true
  }),
  agency: agency,
  keycloak: keycloak,
  patientNumber: patientNumber != null ? String(patientNumber) : undefined,
  ManifestWidget: ManifestWidget
})));